// extracted by mini-css-extract-plugin
export default {"logo":"maintenance_logo__S+qJk"};